import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-modal-confirm',
  templateUrl: './modal-confirm.component.html',
  styleUrls: ['./modal-confirm.component.scss'],
})
export class ModalConfirmComponent implements OnInit {
  @Input() title: any;
  @Input() from: string;
  @Input() nombre: any;
  content: string;

  @Output() clickClose = new EventEmitter();
  @Output() clickDismiss = new EventEmitter();
  @Output() clickCancel = new EventEmitter();

  constructor(
    public activeModal: NgbActiveModal,
    private _translate: TranslateService
  ) {}

  ngOnInit() {
    if (this.from == 'historic') {
      this.content = this._translate.instant('historic.modal.info', {
        name: this.nombre,
      });
    } else if (this.from == 'active') {
      this.content = this._translate.instant('action_plan.modal.info', {
        name: this.nombre,
      });
    } else if (this.from == 'historic_delete') {
      this.content = this._translate.instant('historic.modal.alert_delete', {
        name: this.nombre,
      });
    } else if (this.from == 'save_plan' || this.from == 'add_data') {
      this.content = this._translate.instant('action_plan.modal_save.content');
    } else if (this.from == 'save') {
      this.content = this._translate.instant(
        'action_plan.modal_save.save_plan'
      );
    } else if (this.from == 'descartar') {
      this.content = this._translate.instant(
        'action_plan.modal_save.discard_content'
      );
    } else if (this.from == 'action_historic') {
      this.content = this._translate.instant(
        'action_plan.plan_development.modal_historic.modal_content'
      );
    } else if (this.from == 'delete_action') {
      this.content = this._translate.instant(
        'action_plan.plan_development.confirm_delete',
        { name: this.nombre }
      );
    } else if (this.from == 'delete_selected') {
      this.content = this._translate.instant(
        'action_plan.plan_development.confirm_delete_sel',
        { name: this.nombre.join(', ') }
      );
    } else if (this.from == 'delete_method') {
      this.content = this._translate.instant(
        'action_plan.analisis.methods_diagram.method_delete',
        { name: this.nombre }
      );
    } else if (this.from == 'add_new_action') {
      this.content = this._translate.instant(
        'action_plan.plan_development.confirm_add_new',
        { name: this.nombre }
      );
    } else if (this.from == 'add_method_changes') {
      this.content =
        this._translate.currentLang == 'es'
          ? 'Se perderan los datos que no han sido guardados,¿Desea continuar?'
          : 'The data that has not been saved will be lost, do you want to continue?';
    }
  }

  btnClose() {
    this.clickClose.emit('save');
    this.activeModal.close();
  }

  btnDismiss() {
    this.clickDismiss.emit('dismiss');
    this.activeModal.dismiss();
  }
  btnCancel() {
    this.clickCancel.emit('cancel');
    this.activeModal.dismiss();
  }
}
